import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import VideoFrame from "../../components/media/VideoFrame";
import ErrorState from "../../components/ui/ErrorState";
import { PageSpinner } from "../../components/ui/Spinner";
import client from "../../api/client";
import endpoints from "../../api/endpoints";
import useScrollTop from "../../hooks/useScrollTop";

/**
 * Resolves a stream code and plays it. The play endpoints are POST +
 * IsAuthenticated and may answer with a payment_url instead of a code.
 *
 * @param {"movie"|"episode"} type
 */
const PlayerPage = ({ type }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ code: "", loading: true, error: null });
  useScrollTop();

  useEffect(() => {
    const controller = new AbortController();
    setState({ code: "", loading: true, error: null });

    client
      .post(endpoints.play(type, id), {}, { signal: controller.signal })
      .then(({ data }) => {
        if (data.payment_url) {
          if (data.payment_url.startsWith("http")) {
            window.location.href = data.payment_url;
          } else {
            navigate(data.payment_url);
          }
          return;
        }
        setState({ code: data.code, loading: false, error: null });
      })
      .catch((error) => {
        if (controller.signal.aborted) return;
        const message =
          error.response?.status === 403
            ? error.response?.data?.detail ||
              "برای تماشای این محتوا اشتراک معتبر لازم است."
            : "پخش این محتوا ممکن نشد.";
        setState({ code: "", loading: false, error: message });
      });

    return () => controller.abort();
  }, [type, id, navigate]);

  if (state.loading) return <PageSpinner />;
  if (state.error) return <ErrorState message={state.error} />;

  return (
    <div className="h-screen">
      <VideoFrame code={state.code} title={`player-${id}`} />
    </div>
  );
};

export default PlayerPage;
